export default __webpack_public_path__ + "static/media/3.80d11b91.PNG";